import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { makeStyles } from '@material-ui/styles'
import axios from 'utils/axios'
import { Header, Page } from 'components'
import useRouter from 'utils/useRouter'
import { criarAlerta, logoutTokenExpirado } from 'actions'
import { Results } from './components'

const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(3),
  },
  results: {
    marginTop: theme.spacing(3),
  },
}))

export const LogsServidor = (props) => {
  const { route } = props
  const classes = useStyles()
  const [dados, setDados] = useState([])
  const [carregando, setCarregando] = useState(false)
  const dispatch = useDispatch()
  const router = useRouter()

  useEffect(() => {
    const fetchDados = async () => {
      setCarregando(true)
      try {
        const response = await axios.get('/logServidor/')
        setDados(response.data.logs)
        setCarregando(false)
      } catch (error) {
        if (error.response.status === 401) {
          dispatch(logoutTokenExpirado(router))
        } else {
          dispatch(criarAlerta(error.response, router, '/'))
        }
        setCarregando(true)
      }
    }

    fetchDados()
    
  }, [dispatch, router])

  return (
    <Page className={classes.root} title={`${route.secao} - SIGEP`}>
      <Header titulo={`${route.titulo}`} overline={route.secao} />
      {dados && <Results carregando={carregando} className={classes.results} dados={dados} />}
    </Page>
  )
}
